import { useRef, useState } from "react";
import { CircleHelp, X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { DialogClose } from "@/components/ui/dialog";
import { ViewerAnchoredDialog } from "@/components/viewer/ViewerAnchoredDialog";

export const ViewerControlsHelpDialog = () => {
  const triggerRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        ref={triggerRef}
        onClick={() => setOpen(true)}
        type="button"
        size="icon"
        variant="ghost"
        className="h-[42px] w-[42px] cursor-pointer rounded-lg border border-slate-300 bg-[#eaeef1] text-[#171151] hover:bg-[#dde3e7]"
        aria-label="Afficher l'aide des contrôles"
        title="Afficher l'aide des contrôles"
      >
        <CircleHelp className="h-4 w-4" />
      </Button>

      <ViewerAnchoredDialog
        open={open}
        onOpenChange={setOpen}
        triggerRef={triggerRef}
        title="Contrôles de navigation 3D"
        contentClassName="w-max overflow-hidden"
      >
        <div className="relative" style={{ width: "200px", height: "310px" }}>
          <img
            src="/assets/PIXAtwin_Controls.png"
            alt="Contrôles de navigation 3D"
            className="h-full w-full object-contain"
          />

          <DialogClose asChild>
            <button
              type="button"
              className="absolute right-3 top-3 inline-flex h-6 w-6 items-center justify-center rounded-full bg-black/50 text-white transition-colors hover:bg-black/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
              aria-label="Fermer l'aide"
            >
              <X className="h-4 w-4 stroke-[1.8]" />
            </button>
          </DialogClose>
        </div>
      </ViewerAnchoredDialog>
    </>
  );
};
